"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var fa_1 = require("react-icons/fa");
var model_1 = require("../../model/");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
require("./SideMenu.scss");
var reducers_1 = require("../_shared/reducers");
var _ = require("lodash");
var constants_1 = require("../../constants");
var SideMenuActions_1 = require("./SideMenuActions");
// The order here affects the order the get displayed
var MENU_PAGES = [
    model_1.Permission.PAGE_REALTIME,
    model_1.Permission.PAGE_APP_USERS,
    model_1.Permission.PAGE_PORTAL_USERS,
    model_1.Permission.PAGE_GPS_LOSS_USERS,
    model_1.Permission.PAGE_HOURS,
    model_1.Permission.PAGE_GPS_PROPOSAL,
    model_1.Permission.PAGE_REPORTS,
    model_1.Permission.IMPORT_ADDRESES
];
var SideMenu = /** @class */ (function (_super) {
    __extends(SideMenu, _super);
    function SideMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCompanySelect = function (companyId) {
            // Only reload if the company actually changed
            if (companyId !== _this.props.selectedCompanyId) {
                _this.props.setSelectedCompany(companyId);
                _this.setState({ isCompanyDropdownOpen: false }, function () {
                    // Reload the page to fetch fresh data with new company filter
                    window.location.reload();
                });
            }
            else {
                _this.setState({ isCompanyDropdownOpen: false });
            }
        };
        _this.toggleCompanyDropdown = function () {
            _this.setState(function (prev) { return ({ isCompanyDropdownOpen: !prev.isCompanyDropdownOpen }); });
        };
        _this.lostGpsInterval = null;
        var options = [];
        if (props.user) {
            options = _this.getUserPages(props.user);
        }
        _this.state = { options: options, isCompanyDropdownOpen: false };
        return _this;
    }
    SideMenu.prototype.componentDidMount = function () {
        if (this.props.user && this.state.options.find(function (x) { return x === model_1.Permission.PAGE_GPS_LOSS_USERS; })) {
            this.startLostGpsInterval();
        }
        // Load companies for admin users
        if (this.props.user && this.isAdminUser()) {
            this.props.loadCompanies();
        }
    };
    SideMenu.prototype.isAdminUser = function () {
        var _a;
        var role = (_a = this.props.user) === null || _a === void 0 ? void 0 : _a.role;
        return role === model_1.UserRoles.ADMIN || role === model_1.UserRoles.SUPERADMIN;
    };
    SideMenu.prototype.getUserInitials = function () {
        var user = this.props.user;
        if (!user)
            return '';
        var firstName = user.firstName || user.username || '';
        var lastName = user.lastName || '';
        return "".concat(firstName.charAt(0)).concat(lastName.charAt(0)).toUpperCase();
    };
    SideMenu.prototype.getUserDisplayName = function () {
        var user = this.props.user;
        if (!user)
            return '';
        if (user.firstName || user.lastName) {
            return "".concat(user.firstName || '', " ").concat(user.lastName || '').trim();
        }
        return user.username || '';
    };
    SideMenu.prototype.getRoleDisplayName = function () {
        var user = this.props.user;
        if (!user)
            return '';
        return user.role || '';
    };
    SideMenu.prototype.getSelectedCompanyName = function () {
        var _a = this.props, selectedCompanyId = _a.selectedCompanyId, companies = _a.companies;
        if (!selectedCompanyId)
            return 'All Companies';
        var company = companies.find(function (c) { return c._id === selectedCompanyId; });
        return (company === null || company === void 0 ? void 0 : company.name) || 'All Companies';
    };
    SideMenu.prototype.startLostGpsInterval = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.lostGpsInterval) {
                            return [2 /*return*/];
                        }
                        this.lostGpsInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.props.updateLostGpsUserCount()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, constants_1.LOST_GPS_UPDATE_INTERVAL * 1000);
                        return [4 /*yield*/, this.props.updateLostGpsUserCount()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SideMenu.prototype.stopLostGpsInterval = function () {
        if (this.lostGpsInterval) {
            clearInterval(this.lostGpsInterval);
            this.lostGpsInterval = null;
        }
    };
    SideMenu.prototype.componentWillUnmount = function () {
        if (this.lostGpsInterval) {
            this.stopLostGpsInterval();
        }
    };
    SideMenu.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.user) {
            // We display only the pages which the user has permission
            this.setState({ options: this.getUserPages(newProps.user) });
            if (this.state.options.find(function (x) { return x === model_1.Permission.PAGE_GPS_LOSS_USERS; }) && !this.lostGpsInterval) {
                this.startLostGpsInterval();
            }
        }
    };
    SideMenu.prototype.getUserPages = function (user) {
        var permissions = (0, model_1.userActions)(user);
        // The GPS proposal is granted per user rather than per role, so it cannot
        // come from userActions() like the rest. Admins bypass the flag, matching
        // the backend's own rule.
        if (this.canPreviewGpsProposal(user)) {
            permissions.push(model_1.Permission.PAGE_GPS_PROPOSAL);
        }
        return _.intersection(MENU_PAGES, permissions);
    };
    SideMenu.prototype.canPreviewGpsProposal = function (user) {
        if (!user) {
            return false;
        }
        if (user.role === model_1.UserRoles.ADMIN || user.role === model_1.UserRoles.SUPERADMIN) {
            return true;
        }
        return !!(user.settings && user.settings.canPreviewGpsProposal);
    };
    SideMenu.prototype.navigate = function (opt) {
        var page;
        // Cant redirect to ourselfs again with react navigation dom
        // if (opt === this.props.currentOption) { return; }
        switch (opt) {
            case model_1.Permission.PAGE_REALTIME:
                page = '/map';
                break;
            case model_1.Permission.PAGE_HOURS:
                page = '/hour-control';
                break;
            case model_1.Permission.PAGE_REPORTS:
                page = '/report';
                break;
            case model_1.Permission.PAGE_PORTAL_USERS:
                page = '/portal-users';
                break;
            case model_1.Permission.PAGE_APP_USERS:
                page = '/app-users';
                break;
            case model_1.Permission.PAGE_GPS_LOSS_USERS:
                page = '/gps-loss-users';
                break;
            case model_1.Permission.PAGE_GPS_PROPOSAL:
                page = '/gps-proposal';
                break;
            case model_1.Permission.PAGE_SETTINGS:
                page = '/settings';
                break;
            case model_1.Permission.IMPORT_ADDRESES:
                page = '/import-addresses';
                break;
            case model_1.Permission.LOGOUT:
                this.props.history.replace('/login');
                this.props.logout();
                return;
            default: page = this.props.currentOption;
        }
        this.props.history.push(page);
    };
    SideMenu.prototype.render = function () {
        var _this = this;
        var isCollapsed = this.props.isCollapsed;
        var showCompanySelector = this.isAdminUser() && !isCollapsed;
        return (React.createElement("div", { id: "side-menu", className: isCollapsed ? 'side-menu__collapsed' : 'side-menu__expanded' },
            React.createElement("div", { className: "side-menu__header" },
                React.createElement("i", { className: "side-menu__logo" }),
                React.createElement("span", { className: "side-menu__title visible-expanded" }, "Uren Portaal")),
            React.createElement("div", { className: "side-menu__user-section visible-expanded" },
                React.createElement("div", { className: "side-menu__user-info" },
                    React.createElement("div", { className: "user-avatar" }, this.getUserInitials()),
                    React.createElement("div", { className: "user-details" },
                        React.createElement("div", { className: "user-name" }, this.getUserDisplayName()),
                        React.createElement("div", { className: "user-role" }, this.getRoleDisplayName()))),
                showCompanySelector && (React.createElement("div", { className: "company-selector" },
                    React.createElement("span", { className: "company-selector__label" }, "Active Company"),
                    React.createElement("div", { className: "company-selector__dropdown ".concat(this.state.isCompanyDropdownOpen ? 'open' : ''), onClick: this.toggleCompanyDropdown },
                        React.createElement("span", { className: "company-name" },
                            React.createElement("i", { className: "material-icons company-icon" }, "business"),
                            React.createElement("span", null, this.getSelectedCompanyName())),
                        React.createElement("i", { className: "material-icons arrow" }, "expand_more")),
                    this.state.isCompanyDropdownOpen && (React.createElement("div", { className: "company-selector__options" },
                        React.createElement("div", { className: "company-selector__option ".concat(!this.props.selectedCompanyId ? 'selected' : ''), onClick: function () { return _this.handleCompanySelect(null); } },
                            React.createElement("i", { className: "material-icons company-icon" }, "business"),
                            "All Companies",
                            React.createElement("i", { className: "material-icons check-icon" }, "check")),
                        this.props.companies.map(function (company) { return (React.createElement("div", { key: company._id, className: "company-selector__option ".concat(_this.props.selectedCompanyId === company._id ? 'selected' : ''), onClick: function () { return _this.handleCompanySelect(company._id); } },
                            React.createElement("i", { className: "material-icons company-icon" }, "business"),
                            company.name,
                            React.createElement("i", { className: "material-icons check-icon" }, "check"))); })))))),
            React.createElement("div", { className: "side-menu__list" },
                this.state.options.map(function (opt, index) {
                    return React.createElement("div", { className: opt === _this.props.currentOption ? 'selected menu-item' : 'menu-item', key: index, onClick: function () { return _this.navigate(opt); } },
                        React.createElement("i", { className: "material-icons menu-icon", title: isCollapsed ? opt : '' }, (0, model_1.page_icon)(opt)),
                        React.createElement("span", { className: "visible-expanded" }, opt),
                        opt === model_1.Permission.PAGE_GPS_LOSS_USERS ?
                            React.createElement("span", { className: "lostGpsUserCount visible-expanded" }, _this.props.lostGpsUserCount)
                            : null);
                }),
                React.createElement("div", { className: "menu-item", onClick: function () { return _this.navigate(model_1.Permission.LOGOUT); } },
                    React.createElement("i", { className: "material-icons menu-icon" }, (0, model_1.page_icon)(model_1.Permission.LOGOUT)),
                    React.createElement("span", { className: "visible-expanded" }, model_1.Permission.LOGOUT))),
            React.createElement("div", { className: "side-menu__footer" },
                React.createElement("img", { width: "84", height: "26", src: "/assets/images/logo.png", className: "visible-expanded" }),
                React.createElement("span", { className: "side-menu__date visible-expanded" },
                    "\u00A9 ",
                    new Date().getFullYear()),
                React.createElement("span", { className: "side-menu__toggle", onClick: function () { return _this.props.toggleSideMenu(isCollapsed); } }, isCollapsed
                    ? React.createElement(fa_1.FaAngleDoubleRight, { title: "Expand side menu" })
                    : React.createElement(fa_1.FaAngleDoubleLeft, { title: "Collapse side menu" })))));
    };
    return SideMenu;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        user: reducer.authentication.user,
        isCollapsed: reducer.sideMenuReducer.isCollapsed,
        lostGpsUserCount: reducer.sideMenuReducer.lostGpsUserCount,
        selectedCompanyId: reducer.sideMenuReducer.selectedCompanyId,
        companies: reducer.sideMenuReducer.companies,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    logout: function () { return reducers_1.LoginActions.logout()(dispatch); },
    toggleSideMenu: function (isCollapsed) { return SideMenuActions_1.default.toggleSideMenu(isCollapsed)(dispatch); },
    updateLostGpsUserCount: function () { return SideMenuActions_1.default.updateLostGpsUserCount()(dispatch); },
    setSelectedCompany: function (companyId) { return SideMenuActions_1.default.setSelectedCompany(companyId)(dispatch); },
    loadCompanies: function () { return SideMenuActions_1.default.loadCompanies()(dispatch); },
}); };
var mergeProps = function (stateProps, dispatchProps, ownProps) {
    return __assign(__assign(__assign({}, ownProps), dispatchProps), stateProps);
};
var Container = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(SideMenu);
exports.default = (0, react_router_dom_1.withRouter)(Container);
